import type React from 'react';
import { memo } from 'react';
import { cn } from '@/lib/utils';
const _AIPG = (props: React.SVGProps<SVGSVGElement>) => <svg aria-hidden="true" fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" {...props} className={cn('size-4', props.className)} data-sentry-element="svg" data-sentry-component="_AIPG" data-sentry-source-file="AIPG.tsx">
    <g clipPath="url(#clip0_3848_4112)" data-sentry-element="g" data-sentry-source-file="AIPG.tsx">
      <path d="M7.52911 1.74061C6.88978 3.79261 5.36378 6.37728 1.73044 7.49661C1.25644 7.64261 1.22978 8.31861 1.70378 8.46594C3.76844 9.10728 6.44244 10.6339 7.52778 14.2699C7.66911 14.7439 8.32644 14.7793 8.48044 14.3086C9.14044 12.2866 10.6838 9.64928 14.2924 8.48528C14.7684 8.33194 14.7744 7.66661 14.2971 7.51728C12.2744 6.88594 9.60044 5.37061 8.48444 1.73194C8.33844 1.25528 7.67778 1.26528 7.52911 1.74061Z" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="1.33" data-sentry-element="path" data-sentry-source-file="AIPG.tsx" />
    </g>
    <defs data-sentry-element="defs" data-sentry-source-file="AIPG.tsx">
      <clipPath id="clip0_3848_4112" data-sentry-element="clipPath" data-sentry-source-file="AIPG.tsx">
        <rect fill="white" height="16" width="16" data-sentry-element="rect" data-sentry-source-file="AIPG.tsx" />
      </clipPath>
    </defs>
  </svg>;
const AIPG = memo(_AIPG);
export const AIPGWithIconTag = ({
  className
}: {
  className?: string;
}) => <i data-sentry-component="AIPGWithIconTag" data-sentry-source-file="AIPG.tsx">
    <AIPG className={className} data-sentry-element="AIPG" data-sentry-source-file="AIPG.tsx" />
  </i>;
export default AIPG;